import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web'
import StandardButton from '../app_components/StandardButton'

class VerifyStatus extends React.Component {
  constructor(props) {
    super(props)

    this.state = {

    }

    this.renderStatus = this.renderStatus.bind(this)
    this.renderSubtext = this.renderSubtext.bind(this)
    this.buttonText = this.buttonText.bind(this)
    this.buttonLink = this.buttonLink.bind(this)
  }

  componentDidMount() {

    this.setState({
      status: this.props.id_verification.is_verified ? true : this.props.id_verification.status
    })

    lottie.loadAnimation({
      container: document.getElementById('verifyLottie'),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      name: 'verifyLottie',
      path: this.props.verifyLottie
    });
  }

  renderStatus() {
    if(this.state.status === true) {
      return(
        <span className="darkBlue bold">Complete</span>
      )
    } else if (this.state.status != 'processing') {
      return(
        <span className="bold red">Needs more information</span>
      )
    } else {
      return(
        <span className="darkBlue bold">Processing</span>
      )
    }
  }

  renderSubtext() {
    if(this.state.status === true) {
      return "New feature: only allow other verified users to contact you."
    } else if (this.state.status != 'processing') {
      return "Re-submit your information to complete the identity verification. Once complete, you will unlock a new Pro setting!"
    } else {
      return "When complete: You will have access to a new feature! You can only allow other verified users to contact you."
    }
  }

  buttonText() {
    if(this.state.status === true || this.state.status === 'processing') {
      return "Update Pro Settings"
    }
    return "Verify Identity"
  }

  buttonLink() {
    if(this.state.status === true || this.state.status === 'processing') {
      return  () => window.location.replace('/pro_settings')
    }
    return  () => window.location.replace('/verify_identity_steps')
  }

  render() {
    return(
      <div style={{padding: 10, marginTop: '5%', textAlign: 'center'}}>
        <h3>Status of Identity Verification: {this.renderStatus()}</h3>
        <div id="verifyLottie" style={{width: '100%', height: 200, marginTop: '7%', marginBottom: '7%'}}></div>
        <div style={{maxWidth: 400, margin: 'auto'}}>
        <h5 style={{textAlign: 'left'}}>{this.renderSubtext()}</h5>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginTop: 30}}>
            <StandardButton
              text={this.buttonText()}
              onClick={this.buttonLink()}
              primary={true}
            />
          </div>
        </div>
      </div>
    )
  }

}

export default VerifyStatus
